export default "__VITE_ASSET__H6IY0LTy__"